import { GraphQlBuilderError } from "./GraphQlBuilderError.js";
import { ObjectBuilder } from "./ObjectBuilder.js";
import { isEmptyObject } from "../utils/isEmptyObject.js";
class RootObjectBuilder {
  constructor(objects = {}, fragmentDefinitions = {}) {
    this.objects = objects;
    this.fragmentDefinitions = fragmentDefinitions;
  }
  fragment(name, builder) {
    if (!(builder instanceof ObjectBuilder)) {
      builder = builder(new ObjectBuilder());
    }
    if (!isEmptyObject(builder.args)) {
      throw new GraphQlBuilderError(`Cannot supply args to Graph QL fragments!`);
    }
    if (!builder.objectName) {
      throw new GraphQlBuilderError(`Object names are mandatory for Graph QL fragments!`);
    }
    return new RootObjectBuilder(this.objects, { ...this.fragmentDefinitions, [name]: builder });
  }
  object(name, builder) {
    if (!(builder instanceof ObjectBuilder)) {
      builder = builder(new ObjectBuilder());
    }
    return new RootObjectBuilder({ ...this.objects, [name]: builder }, this.fragmentDefinitions);
  }
}
export {
  RootObjectBuilder
};
//# sourceMappingURL=RootObjectBuilder.js.map
